<template>

<div class="team inner">

    <div class="team-title">{{ item.title }}</div>

    <div class="team-profiles">

        <div class="team-profiles-item" v-for="(person, index) in item.people" :key="index">

            <div class="team-profiles-item-image" v-bgimage="person.image" />

            <div class="team-profiles-item-name">{{ person.name }}</div>

            <div class="team-profiles-item-role">{{ person.role }}</div>

            <div class="team-profiles-item-phone" v-if="person.phone">{{ person.phone }}</div>

            <div class="team-profiles-item-email" v-if="person.email">{{ person.email }}</div>

        </div>

    </div>

</div>

</template>

<script>

export default {

    props: ['item']

}

</script>

<style scoped>

.team-title {
    color: #00583D;
    font-size: 35px;
    line-height: 40px;
    font-weight: 400;
    font-family: "Montserrat", sans-serif;
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 48px;
}

.is-tablet .team-title {
    font-size: 28px;
    line-height: 32px;
}

.is-mobile .team-title {
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 20px;
}

.team-profiles {
    display: grid;
    grid-template-columns: repeat(auto-fit, 25%);
    justify-content: center;
    grid-gap: 20px;
}

.is-tablet .team-profiles {
    grid-template-columns: repeat(auto-fit, 33.3%);
}

.is-mobile .team-profiles {
    grid-template-columns: 1fr;
}

.team-profiles-item {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.team-profiles-item-image {
    width: 218px;
    height: 350px;
    background-position: 50% 50%;
    background-size: cover;
    margin-bottom: 40px;
}

.team-profiles-item-image:after {
    content: '';
    display: block;
    position: absolute;
    left: 0px;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-position: 50% 0px;
    background-repeat: no-repeat;
    top: 0px;
    z-index: 2;
    background-image: url('data:image/png;base64,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');
}

.is-tablet .team-profiles-item-image {
    width: 130px;
    height: 210px;
    margin-bottom: 30px;
}

.is-mobile .team-profiles-item-image {
    width: 100px;
    height: 160px;
    margin-bottom: 20px;
}

.team-profiles-item-name {
    color: #00583D;
    font-weight: 400;
    font-family: "Montserrat", sans-serif;
    font-size: 24px;
    line-height: 28px;
}

.is-mobile .team-profiles-item-name {
    font-size: 16px;
    line-height: 24px;
}

.team-profiles-item-role,
.team-profiles-item-phone,
.team-profiles-item-email {
    color: #45464B;
    font-weight: 500;
    font-family: "Montserrat", sans-serif;
    font-size: 16px;
    line-height: 28px;
}

.is-tablet .team-profiles-item-role,
.is-tablet .team-profiles-item-phone,
.is-tablet .team-profiles-item-email {
    font-size: 14px;
    line-height: 24px;
}

.is-mobile .team-profiles-item-role,
.is-mobile .team-profiles-item-phone,
.is-mobile .team-profiles-item-email {
    font-size: 13px;
    line-height: 24px;
}

</style>
